import Project1 from "../../assets/project1.webp";
import Project2 from "../../assets/project2.webp";
import Project3 from "../../assets/project3.webp";


export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "Driving Test AI",
        category: "Native",
        tools: ['Kotlin', 'XML', 'TFLite', 'MediaPipe', 'KTOR', 'Camera2', 'Retrofit'],
    },
    {
        id: 2,
        image: Project2,
        title: "KSWMP Officer App",
        category: "ReactNative",
        tools: ['JavaScript', 'ReduxSaga', 'Native-Base', 'IcoMoon', 'GeoLocation', 'Formik'],
    },
    {
        id: 3,
        image: Project2,
        title: "KSWMP Grievance App",
        category: "ReactNative",
        tools: ['JavaScript', 'ReduxSaga', 'Native-Base', 'IcoMoon', 'GeoLocation', 'Formik'],
    },
    {
        id: 4,
        image: Project2,
        title: "Bahrain Survey",
        category: "ReactNative",
        tools: ['JavaScript', 'IcoMoon', 'GeoLocation', 'GoogleMap'],
    },
    {
        id: 5,
        image: Project2,
        title: "EV Charging Station",
        category: "JavaScript",
        tools: ['JavaScript', 'IcoMoon', 'GeoLocation', 'GoogleMap'],
    },
    {
        id: 6,
        image: Project2,
        title: "CSML",
        category: "ReactNative",
        tools: ['JavaScript', 'IcoMoon', 'Paper', 'VLC-Player', 'ReduxToolKit', 'Axios', 'Formik'],
    },
    {
        id: 7,
        image: Project2,
        title: "SafeKerala",
        category: "ReactNative",
        tools: ['JavaScript', 'Native-Base', 'ReduxSaga', 'Formik'],
    },
    {
        id: 8,
        image: Project3,
        title: "MIS",
        category: "ReactJS",
        tools: ['JavaScript', 'MaterialUI', 'ReduxSaga', 'Formik', 'Axios', 'i18', 'chartjs'],
    },
    {
        id: 9,
        image: Project2,
        title: "Platinum 24 POS",
        category: "ReactNative",
        tools: ['JavaScript', 'ReduxThunk', 'Formik'],
    },
    {
        id: 10,
        image: Project1,
        title: "FoodHeart",
        category: "Native",
        tools: ['Java','XML','FCM'],
    },
];

export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "Native",
    },
    {
        name: "ReactNative",
    },
    {
        name: "ReactJS",
    },
];